module.exports = __webpack_public_path__ + "img/icn_play.4337dcb6.svg";